import styled from '@emotion/styled';

export const MainSelectorWrapper = styled.div`
  min-width: 40px;
`;
